var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"collapse",class:{
        collapsed: _vm.hide
    },style:({
        'max-height': _vm.hide ? _vm.minHeight+'px' : _vm.height,
        'overflow': _vm.overflow
    }),on:{"transitionend":_vm.transitionEnd,"transitioncancel":_vm.transitionEnd}},[_c('div',{staticClass:"collapse-inner"},[_vm._t("default")],2),_vm._v(" "),(_vm.minHeight > 0)?_c('div',{staticClass:"collapse-mist",class:{
            active: _vm.hide
        }}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }